// extracted by mini-css-extract-plugin
module.exports = {"cell-container":"VIP_AverageWeekSales__cell-container","cellContainer":"VIP_AverageWeekSales__cell-container"};